import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListFromValues, hasChangedValues, getFormValue, changeItemsValue, getListItems } from '../../public/utility'
import { concat } from 'lodash'
import ExpenseOrder from './ExpenseOrder'
class AddExpenseOrder extends React.Component {
    state = {}

    handlerSave = () => {
        const { onClose, onSave, showDetail, advanceExpenseID } = this.props
        const { changedValues基本信息 } = this.state
        if (advanceExpenseID && advanceExpenseID > 0) {
            Tyan.doPostEvent({
                event: 'CreateExpenseOrder',
                data: { advanceExpenseID, changedValues基本信息 },
                onEnd: ({ errorMessage, id }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    onClose && onClose()
                    showDetail(props => <ExpenseOrder {...props} id={id} onSave={() => onSave()} />)
                }
            })
        } else {
            onClose && onClose()
            showDetail(props => <ExpenseOrder {...props} id={-1} expenseName={changedValues基本信息.报支类别} />)
        }
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    canSave = () => {
        return getFormValue(this, '基本信息', '报支类别')
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        return [
            { _radio: '', name: '报支类别', itemMinWidth: 125, minWidth: '95%', items: ['采购报支单', '一般报支单', '福利金报支单', '出差/外训报支单', '交际费报支单', '委外测试费报支单'], required: true }
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { errorMessage, initValues基本信息, bReadOnly } = this.state
        if (errorMessage) return <Message text={errorMessage} />
        const canSave = this.canSave()
        const bChanged = this.bChanged()
        return <Body data={this} maxWidth="700"
            controls={
                bReadOnly ?
                    [
                        { _button: bChanged && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    ] : [
                        { _button: '确定', icon: 'save', handler: this.handlerSave, disabled: !(canSave && bChanged) },
                        { _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
                ]}
        />
    }
}

export default connect()(AddExpenseOrder)